import React from "react";
import { Audit} from "../containers/audit/Audit";

export function AuditPage() {
  return <Audit/>;
}